module.exports = __webpack_public_path__ + "static/clouds-7f31b7bf7f4912fc4ff1e33e4ef673f5.png";